import { Controller } from '@hotwired/stimulus';
import { changeLoadingState } from './views/buttons';

export default class extends Controller {
  changeLoadingState(event) {
    changeLoadingState(event);
  }
}
